<template>
  <div class="main">
    <div class="wrap-particles">
      <div class="main-content">
        <!-- <b-navbar style="background-color: #fff;">
          <b-navbar-brand>
            <img src="@/assets/logo.png" style="height:40px;">
          </b-navbar-brand>
        </b-navbar> -->

        <div class="container py-4 text-center text-white h-75">
          <div v-if="hasMotion" class="h-100">
            <h1>Shake the phone</h1>

            <div class="d-flex justify-content-center align-items-center h-100">
              <h1 class="display-1 mono">{{intToString}}</h1>
            </div>
          </div>

          <div v-else class="d-flex justify-content-center align-items-center h-100">
            <div>
            <img src="@/assets/meteorite.svg" class="w-50">
            <h3 class="text-white">Sorry, this game is not compatible with your device or browser.</h3>
            </div>
          </div>
        </div>
      </div>

      <vue-particles color="#ffffff" :particleOpacity="0.3" :particlesNumber="80" shapeType="circle" :particleSize="5"
        :lineLinked="false" :moveSpeed="1" :hoverEffect="false" :clickEffect="false" />
    </div>
  </div>
</template>

<script>
let Shake = require('shake.js')

export default {
  data() {
    return {
      val: 0,
      hasMotion: false,
    }
  },
  computed: {
    intToString() {
      let count = this.val
      const COUNT_ABBRS = [ '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y' ]
      const i = 0 === count ? count : Math.floor(Math.log(count) / Math.log(1000))
      let result = parseFloat((count / Math.pow(1000, i)).toFixed(2))
      return result += `${COUNT_ABBRS[i]}`
    }
  },
  mounted() {
    let self = this

    let myShakeEvent = new Shake()

    myShakeEvent.start()

    window.addEventListener('shake', shakeEventDidOccur, false)

    //function to call when shake occurs
    function shakeEventDidOccur() {

      //put your own code here etc.
      self.val += 1
    }

    window.addEventListener("devicemotion", function (event) {
      if (event.rotationRate.alpha || event.rotationRate.beta || event.rotationRate.gamma)
        self.hasMotion = true
    })
  }
}
</script>

<style scoped>
.main {
  width: 100vw;
  min-height: 100vh;
  background-color: #000;
}
</style>
